const RELOAD_AT_KEY = "ailechat:chunk-reload-at";

// A tab opened before a deploy still requests the previous build's hashed chunks. Pages answers a missing
// chunk with index.html (200 text/html), so the dynamic import fails and, without handling, React unmounts
// the whole app. Reload once to pick up the current build; a second failure within a minute is a real error
// and is left to the app error boundary instead of reloading in a loop.
export function reloadForNewBuild(): boolean {
  try {
    const last = Number(sessionStorage.getItem(RELOAD_AT_KEY) || 0);
    if (Date.now() - last < 60_000) return false;
    sessionStorage.setItem(RELOAD_AT_KEY, String(Date.now()));
  } catch {
    return false;
  }
  window.location.reload();
  return true;
}

export function importWithReload<T>(load: () => Promise<T>): () => Promise<T> {
  return () => load().catch((error: unknown) => {
    if (reloadForNewBuild()) return new Promise<T>(() => {});
    throw error;
  });
}
